import { Volume2 } from "lucide-react";
import { useT } from "../context/LanguageContext";

// Plays an admin-recorded/uploaded voice announcement (public media URL).
export function AudioNote({ src, label = "Voice announcement", testid = "audio-note" }) {
  const { t } = useT();
  if (!src) return null;
  const full = src.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`;
  return (
    <div className="mt-3" data-testid={testid}>
      <p className="text-[11px] font-bold uppercase tracking-wider text-clinical mb-1 flex items-center gap-1">
        <Volume2 className="w-3.5 h-3.5" /> {t(label)}
      </p>
      <audio controls src={full} className="w-full h-9" data-testid={`${testid}-player`} />
    </div>
  );
}
